import { MdCopyright, MdOutlineKeyboardArrowDown } from 'react-icons/md'
import { BsArrowReturnRight } from 'react-icons/bs'
import { cnpjCpfMask, parseDate } from '../../utils/masks'
import { ContratoProtocol } from '../../Pages/Extratos/interfaces'
import { useState } from 'react'
import { BiDollarCircle, BiLink } from 'react-icons/bi'
import { RiExchangeDollarLine } from 'react-icons/ri'
import { StyledTr } from './styles'
import { VscCircle } from 'react-icons/vsc'
import { TbReceipt2 } from 'react-icons/tb'
import { Tooltip } from '@mui/material'

import {
    BsFillArrowLeftCircleFill,
    BsFillArrowRightCircleFill,
} from 'react-icons/bs'
import { useCredenciadoras } from '../../hooks/credenciadoras'

interface Props {
    contract: ContratoProtocol
    handleSelectContract: (contract: ContratoProtocol) => void
}
const RowsTableExtratos = ({ contract, handleSelectContract }: Props) => {
    const [showCommission, setShowCommission] = useState(false)
    const { todasCredenciadoras } = useCredenciadoras()
    // const crendeciadora: keyof typeof todasCredenciadoras =
    //     contract.credenciadora as keyof typeof todasCredenciadoras
    const nomeCredeciadora = todasCredenciadoras[contract?.credenciadora]

    // const crendeciadoraComissao: keyof typeof todasCredenciadoras = contract
    //     ?.comissao?.credenciadora as keyof typeof todasCredenciadoras
    const nomeCredeciadoraComissao =
        todasCredenciadoras[contract?.comissao?.credenciadora]

    function renderContractValue(compara_pagador: boolean, situacao: string) {
        if (
            compara_pagador === true &&
            ['Confirmado', 'Baixado', 'Liquidado'].indexOf(situacao) !== -1
        ) {
            return (
                <td
                    className="negative circle valor"
                    onClick={() => handleSelectContract(contract)}
                >
                    <span>
                        -{' '}
                        {Number(contract.saldoDevedor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </td>
            )
        } else if (
            compara_pagador === false &&
            ['Confirmado', 'Baixado', 'Liquidado'].indexOf(situacao) !== -1
        ) {
            return (
                <td
                    className="positive circle"
                    onClick={() => handleSelectContract(contract)}
                >
                    <span>
                        +{' '}
                        {Number(contract.saldoDevedor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </td>
            )
        } else if (situacao === 'Pendente') {
            return (
                <td className="" onClick={() => handleSelectContract(contract)}>
                    <span>
                        {Number(contract.saldoDevedor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </td>
            )
        } else if (situacao === 'Cancelado') {
            return (
                <td
                    className="denied circle"
                    onClick={() => handleSelectContract(contract)}
                >
                    <span>
                        {Number(contract.saldoDevedor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </td>
            )
        } else if (situacao === 'Recusado') {
            return (
                <td
                    className="denied circle"
                    onClick={() => handleSelectContract(contract)}
                >
                    <span>
                        {Number(contract.saldoDevedor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </td>
            )
        }
    }

    function renderContractSituation(
        situacao: string,
        compara_pagador: boolean
    ) {
        if (situacao === 'Confirmado') {
            return (
                <td
                    className="small-circle confirmed-situation"
                    onClick={() => handleSelectContract(contract)}
                >
                    <VscCircle size={16} />{' '}
                    {!contract.visibilidade ? 'Pendente' : situacao}
                </td>
            )
        } else if (situacao === 'Liquidado') {
            return (
                <td
                    className="small-circle settled-situation"
                    onClick={() => handleSelectContract(contract)}
                >
                    <VscCircle size={16} />{' '}
                    {!contract.visibilidade ? 'Pendente' : situacao}
                </td>
            )
        } else if (situacao === 'Baixado') {
            return (
                <td
                    className="small-circle settled-situation"
                    onClick={() => handleSelectContract(contract)}
                >
                    <VscCircle size={16} />{' '}
                    {!contract.visibilidade ? 'Pendente' : situacao}
                </td>
            )
        } else if (situacao === 'Recusado') {
            return (
                <td
                    className="small-circle denied-situation"
                    onClick={() => handleSelectContract(contract)}
                >
                    <VscCircle size={16} />{' '}
                    {!contract.visibilidade ? 'Pendente' : situacao}
                </td>
            )
        } else if (situacao === 'Cancelado') {
            return (
                <td
                    className="small-circle denied-situation"
                    onClick={() => handleSelectContract(contract)}
                >
                    <VscCircle size={16} />{' '}
                    {!contract.visibilidade ? 'Pendente' : situacao}
                </td>
            )
        } else {
            return (
                <td
                    className="small-circle pending-situation"
                    onClick={() => handleSelectContract(contract)}
                >
                    <VscCircle size={16} />{' '}
                    {!contract.visibilidade ? 'Pendente' : situacao}
                </td>
            )
        }
    }

    function renderContractType(contract: ContratoProtocol) {
        if (contract.recorrenciaId && contract.linkDePagamentoId === null) {
            return (
                <Tooltip title="Recorrência" placement="top">
                    <span>
                        <RiExchangeDollarLine color="#333" size={22} />
                    </span>
                </Tooltip>
            )
        } else if (contract.linkDePagamentoId) {
            if (contract.recorrenciaId) {
                return (
                    <Tooltip title="Cobrança (Recorrência)" placement="top">
                        <div className="flex items-center gap-x-1">
                            <span>
                                <BiLink color="#333" size={22} />
                            </span>
                            /
                            <span>
                                <RiExchangeDollarLine color="#333" size={22} />
                            </span>
                        </div>
                    </Tooltip>
                )
            }
            return (
                <Tooltip title="Cobrança" placement="top">
                    <span>
                        <BiLink color="#333" size={22} />
                    </span>
                </Tooltip>
            )
        } else if (contract.anticipationId) {
            return (
                <Tooltip title="Antecipação" placement="top">
                    <span>
                        <TbReceipt2 color="#333" size={22} />
                    </span>
                </Tooltip>
            )
        } else {
            return (
                <Tooltip title="Pagamento" placement="top">
                    <span>
                        <BiDollarCircle color="#333" size={22} />
                    </span>
                </Tooltip>
            )
        }
    }

    return (
        <>
            <StyledTr key={contract.id}>
                {contract.comissaoId === null ? (
                    <td></td>
                ) : (
                    <td onClick={() => setShowCommission(!showCommission)}>
                        <span
                            className={showCommission ? 'arrow' : 'arrow down'}
                        >
                            <MdOutlineKeyboardArrowDown size={18} />
                        </span>
                    </td>
                )}
                <td onClick={() => handleSelectContract(contract)}>
                    {parseDate(contract.dataAssinatura, true)}
                </td>
                <td onClick={() => handleSelectContract(contract)}>
                    {contract.compara_pagador
                        ? cnpjCpfMask(contract.cnpjRecebedor)
                        : cnpjCpfMask(contract.cnpjPagador)}
                </td>
                <td onClick={() => handleSelectContract(contract)}>
                    {contract.compara_pagador
                        ? contract.nomeRecebedor
                        : contract.nomePagador}
                </td>
                {/* <td onClick={() => handleSelectContract(contract)}><strong>De:</strong> {cnpjCpfMask(contract.cnpjPagador)} <br /> <strong>Para:</strong> {cnpjCpfMask(contract.cnpjRecebedor)}</td> */}
                {/* <td onClick={() => handleSelectContract(contract)}><strong>De:</strong> {contract.nomePagador} <br /> <strong>Para:</strong> {contract.nomeRecebedor}</td> */}
                <td onClick={() => handleSelectContract(contract)}>
                    {nomeCredeciadora}
                </td>
                <td onClick={() => handleSelectContract(contract)}>
                    {contract.compara_pagador ? (
                        <Tooltip title="Pago" placement="top">
                            <span>
                                <BsFillArrowLeftCircleFill
                                    size={18}
                                    color="rgb(202, 12, 29)"
                                />
                            </span>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Recebido" placement="top">
                            <span>
                                <BsFillArrowRightCircleFill
                                    size={18}
                                    color="#0b700b"
                                />
                            </span>
                        </Tooltip>
                    )}
                </td>
                {/* <td onClick={() => handleSelectContract(contract)}>{Number(contract.saldoDevedor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td> */}
                {renderContractValue(
                    contract.compara_pagador,
                    contract.situacao.split(' ')[0]
                )}
                <td onClick={() => handleSelectContract(contract)}>
                    {renderContractType(contract)}
                </td>
                {renderContractSituation(
                    contract?.situacao.split(' ')[0],
                    contract.compara_pagador
                )}
                {/* <td className='small-circle confirmed-situation' onClick={() => handleSelectContract(contract)}><VscCircle /> {!contract.visibilidade ? 'Pendente' : contract.situacao.split(' ')[0]}</td> */}
                {/* <td onClick={() => handleSelectContract(contract)}>{!contract.visibilidade ? (
                    <BsClock color='#d46700' size={22} />
                ) : (
                    contract.situacao === 'Recusado' || contract.situacao === 'Cancelado' ? (
                        <BsXCircle color='#de4126' size={22} />
                    ) : (
                        <>
                            {contract.situacao === 'Confirmado' || contract.situacao === 'Liquidado' || contract.situacao === 'Baixado' ? (
                                <BsCheckCircle color='#88c425' size={22} />
                            ) : (
                                <BsClock color='#d46700' size={22} />
                            )}
                        </>
                    )
                )}</td> */}
            </StyledTr>

            {showCommission && contract.comissaoId !== null && (
                <StyledTr
                    key={contract?.comissao?.id}
                    onClick={() => handleSelectContract(contract?.comissao)}
                >
                    <td className="arrow-commission">
                        <BsArrowReturnRight size={20} />
                    </td>
                    <td>
                        {parseDate(contract?.comissao?.dataAssinatura, true)}
                    </td>
                    <td>{cnpjCpfMask(contract?.comissao?.cnpjRecebedor)}</td>
                    <td>{contract?.comissao?.nomeRecebedor}</td>
                    <td>{nomeCredeciadoraComissao}</td>
                    <td>
                        <Tooltip title="Pago" placement="top">
                            <span>
                                <BsFillArrowLeftCircleFill
                                    size={18}
                                    color="rgb(202, 12, 29)"
                                />
                            </span>
                        </Tooltip>{' '}
                    </td>
                    {/* <td>{!contract?.comissao?.visibilidade ? 'Pendente' : contract?.comissao?.situacao?.split(' ')[0]}</td> */}
                    <td className="negative circle">
                        <span>
                            {['Confirmado', 'Baixado', 'Liquidado'].indexOf(
                                contract?.comissao?.situacao.split(' ')[0]
                            ) !== -1
                                ? '-'
                                : ''}{' '}
                            {Number(
                                contract?.comissao?.saldoDevedor
                            ).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </span>
                    </td>
                    <td onClick={() => handleSelectContract(contract)}>
                        <Tooltip title="Taxa" placement="top">
                            <span>
                                <MdCopyright color="#333" size={22} />
                            </span>
                        </Tooltip>
                    </td>
                    {/* <td>{!contract?.comissao?.visibilidade ? (
                        <BsClock color='#d46700' size={22} />
                    ) : (
                        contract?.comissao?.situacao === 'Recusado' || contract?.comissao?.situacao === 'Cancelado' ? (
                            <BsXCircle color='#de4126' size={22} />
                        ) : (
                            <>
                                {contract?.comissao?.situacao === 'Confirmado' || contract?.comissao?.situacao === 'Liquidado' ? (
                                    <BsCheckCircle color='#88c425' size={22} />
                                ) : (
                                    <BsClock color='#d46700' size={22} />
                                )}
                            </>
                        )
                    )}</td> */}
                    {renderContractSituation(
                        contract?.comissao?.situacao.split(' ')[0],
                        true
                    )}
                </StyledTr>
            )}
        </>
    )
}

export default RowsTableExtratos
